import { useEffect } from "react";

/**
 * The page's scroll lock on mobile — ONE lock, shared and counted.
 *
 * WHY <html>. phrResponsive's `html, body { overflow-x: hidden }` makes <html>
 * the page's scroller at every width, so body's overflow never reaches the
 * viewport. A lock on <body> alone — which is what most desktop dialogs take,
 * and what ModalPortal holds while any portal is mounted — leaves the page free
 * to scroll behind the overlay. Measured on mobile Create Rx.
 *
 * WHY COUNTED — the same pattern ModalPortal uses for <body>. Each holder used
 * to save the overflow it found and put that back on release, which breaks the
 * moment two hold it: the second saves the first's "hidden". When both go in
 * one commit — a nested sheet's row navigating away — React 16 runs unmount
 * cleanups parent first, so the inner holder's restore of "hidden" lands last
 * and the next screen cannot scroll (Step 74). Counted, the order does not
 * matter: the last holder out puts back what was there before the first came in.
 */
let holders = 0;
let saved = null;

export const lockScroll = () => {
  if (holders === 0) {
    saved = {
      body: document.body.style.overflow,
      root: document.documentElement.style.overflow,
    };
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
  }
  holders += 1;
};

export const unlockScroll = () => {
  holders -= 1;
  if (holders > 0) return;
  document.body.style.overflow = saved.body;
  document.documentElement.style.overflow = saved.root;
  saved = null;
};

/**
 * Holds the lock while `active` is true.
 *
 * For overlays this layer does not own — a desktop dialog a mobile screen
 * renders, whose own lock is on <body> alone or missing — so the screen that
 * knows the dialog is open holds the lock for it. The dialog itself is left
 * exactly as desktop has it.
 */
export const useScrollLock = (active) => {
  useEffect(() => {
    if (!active) return undefined;
    lockScroll();
    return unlockScroll;
  }, [active]);
};
